import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./navItem.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const resolveLinkPath = (childTo, parentTo) => `${parentTo}/${childTo}`;

const NavItemHeader = (props) => {
  const { item } = props;
  const { label, Icon, to: headerToPath, children, isNew, show } = item;
  const location = useLocation();

  const [expanded, setExpand] = useState(
    location.pathname.includes(headerToPath)
  );

  const onExpandChange = (e) => {
    e.preventDefault();
    setExpand((expanded) => !expanded);
  };

  return (
    <>
      {show && (
        <>
          <button
            className="secondary_navItem navItemHeaderButton"
            onClick={onExpandChange}
          >
            <FontAwesomeIcon icon={Icon} className="navIcon" />
            <span className="navLabel">{label}</span>
            <FontAwesomeIcon
              className={`${
                expanded && `chevronExpanded `
              }   navItemHeaderChevron`}
              icon={faChevronDown}
              size={20}
            />
          </button>

          {expanded && (
            <div className="navChildrenBlock">
              {children.map((item, index) => {
                const key = `${item.label}-${index}`;

                const { label, Icon, children } = item;
                console.log(resolveLinkPath(item.to, props.item.to));

                if (children) {
                  return (
                    <div key={key}>
                      <NavItemHeader
                        item={{
                          ...item,
                          to: resolveLinkPath(item.to, props.item.to),
                        }}
                      />
                    </div>
                  );
                }

                return (

                  
                  <NavLink
                    key={key}
                    to={resolveLinkPath(item.to, props.item.to)}
                    className="secondary_navItem"
                    activeClassName="activeNavItem"
                  >
                    <FontAwesomeIcon icon={Icon} className="navIcon" />
                    <span className="navLabel">{label}</span>
                    {isNew && <span className="new-badge">New</span>}
                  </NavLink>
                );
              })}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default NavItemHeader;
